import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { MapToolbarProps } from '../../../types/infrastructure-map'
import { ActionsBar, StyleSelector, ZoomControls } from './map-toolbar/map-toolbar.parts'

export function MapToolbar(props: MapToolbarProps): ReactElement {
  const { t } = useTranslation('cases')
  const {
    currentStyle,
    onStyleChange,
    isLinkCreationActive,
    onToggleLinkCreation,
    onRecalculateLayout,
    onZoomIn,
    onZoomOut,
    onResetZoom,
    canUndo,
    canRedo,
    onUndo,
    onRedo,
  } = props

  return (
    <div className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-2 dark:border-slate-700 dark:bg-slate-800">
      <StyleSelector currentStyle={currentStyle} onStyleChange={onStyleChange} t={t} />
      <ActionsBar
        isLinkCreationActive={isLinkCreationActive}
        onToggleLinkCreation={onToggleLinkCreation}
        onRecalculateLayout={onRecalculateLayout}
        canUndo={canUndo}
        canRedo={canRedo}
        onUndo={onUndo}
        onRedo={onRedo}
        t={t}
      />
      <ZoomControls onZoomIn={onZoomIn} onZoomOut={onZoomOut} onResetZoom={onResetZoom} t={t} />
    </div>
  )
}

export default MapToolbar
